import React from 'react';
import { useState } from 'react';
import { generateRandomID } from '../../../../../util/lib';

import HeaderSubMenu from './HeaderSubMenu';
import './scss/SecondaryMenu.scss';


const SecondaryMenu = (props = {}) => {
	const { userName = '', data = {} } = props,
		[ guid ] = useState(generateRandomID(4));

	return (<ul className="secondary-menu navbar-nav user-profile-button">
		<li className="nav-item dropdown">
			<HeaderSubMenu
				id={`header-sec-mnu-${guid}`}
				data={data}
				title={userName}
				faIconClass={'vt vt-usersolid'}
				mobileDisplayNav={props.mobileDisplayNav}
			/>
		</li>
	</ul>);
};

export default SecondaryMenu;